var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H0V2.0625L4.28571 5.5L0 8.9375V11H10V8.9375H2.85714L7.14286 5.5L2.85714 2.0625H10V0Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum);
export default __webpack_public_path__ + "static/media/sum.aedc582d758de58b1d9fda810dcdeee1.svg";
export { ForwardRef as ReactComponent };